import { render, staticRenderFns } from "./AssetIssues.vue?vue&type=template&id=72e156bc&scoped=true&"
import script from "./AssetIssues.vue?vue&type=script&lang=js&"
export * from "./AssetIssues.vue?vue&type=script&lang=js&"
import style0 from "./AssetIssues.vue?vue&type=style&index=0&id=72e156bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e156bc",
  null
  
)

export default component.exports